/*
 * Jira Ticket:
 * Created Date: Mon, 8th Jun 2020, 10:45:36 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getListCapabilitiesQuery = gql`
  query Capabilities {
    items: capabilities {
      id
      description
    }
  }
`;

export default async ({ client, params }) => {
  try {
    const result = await client.query({
      query: getListCapabilitiesQuery,
      variables: {},
      fetchPolicy: 'network-only',
    });
    result.data.total = result.data.items.length;
    return result;
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
